import './index.erb';
import './index.rb';

(() => {
  'use strict';

  const bindingForm = () => {
    const $form = $('#search-question');
    const { proceed, reason } = window.permissions.hasPermissions([
      'account',
      'confirmed_account'
    ]);

    if ($form) {
      $form.on('submit', e => {
        if (!proceed) {
          e.preventDefault();

          window.permissions.feedbacks[reason]({
            detail: {
              type: 'search_question'
            }
          });

          return false;
        }

        return true;
      });
    }
  };

  $(document).on('turbolinks:load', () => {
    bindingForm();
  });

  bindingForm();
})();
